// extracted by mini-css-extract-plugin
export default {"noBackground":"Raa-z","qnaContainer":"Saa-z","qna":"Taa-z","question":"Uaa-z","modal":"Vaa-z"};